import { Alert, Card, CardContent, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { EstudianteActivoT } from "../../interfaces/SAAC/EstudianteActivo";

interface Props {
    estudiante: EstudianteActivoT;
}

export const EstudianteTabla: React.FC<Props> =({ estudiante })=>{
    const locale = navigator.language;
    //console.log(estudiante);
    return(
        <>
        <br />
        <Card sx={{ border: '1px solid #243165' }}>
            <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                    Información del Estudiante
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <strong>Matricula: </strong>{estudiante.matricula}
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <strong>Nombre: </strong>{estudiante.nombre}
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <strong>Carrera: </strong>{estudiante.nombrecarrera}
                </Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Créditos Regulares</TableCell>
                                <TableCell>Promedio</TableCell>
                                <TableCell>Num. Aprobadas</TableCell>
                                <TableCell>Duración Carrera</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key={'est-0'}>
                                <TableCell>{estudiante.creditosregular}</TableCell>
                                <TableCell>
                                    {new Intl.NumberFormat(locale, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(estudiante.promedio)}
                                </TableCell>
                                <TableCell>{estudiante.numaprobadas}</TableCell>
                                <TableCell>{estudiante.duracioncarrera+" años"}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                    {estudiante.estudianteValido.length > 0 ?
                    <>
                    <br />
                      <Alert severity="error">
                        Se presentaron los siguientes inconvenientes con el estudiante:
                      </Alert>
                      <br /> 
                      <Container style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start', // Cambiado a 'flex-start' para alinear a la izquierda
                        textAlign: 'left',        // Cambiado a 'left' para alinear el texto a la izquierda
                        }}>
                        {estudiante.estudianteValido.map((mensaje, i) => (
                        <div key={i}>
                            <strong>{i+1}.</strong> {mensaje.mensaje}
                        </div>
                        ))}
                      </Container>
                    </>
                    : <></>}
            </CardContent>
        </Card>
        </>
        
    )
};